module.exports = __webpack_public_path__ + "img/2.733cc7cf.png";